import TextContent from '../../Molecules/TextContent';

function PrivacyPolicy() {
  return (
    <div className="flex flex-col items-center justify-between py-20">
      <div className="mx-auto w-full max-w-7xl px-7 text-sl-blue">
        <TextContent>
          <h1>Privacy Statement</h1>
          <p>
            <strong>
              Synsel Techniek houdt zich aan de wetgeving
              rond de bescherming van persoonsgegevens. Alle
              privacygevoelige informatie die je aan ons
              verstrekt, valt onder deze privacyverklaring.
              De bedoeling van deze verklaring is je te
              informeren over de manier waarop wij
              persoonsgegevens die je via deze website
              verstrekt zullen gebruiken.
            </strong>
          </p>
          <p>
            <strong>
              Wijziging van de privacy statement
            </strong>
          </p>
          <p>
            Synsel Techniek behoudt zich het recht voor om
            de inhoud van deze privacy statement te
            wijzigen. Deze privacy statement is afgestemd op
            het gebruik van en de mogelijkheden op de
            website van Synsel Techniek. Eventuele
            aanpassingen en/of veranderingen van deze
            website, kunnen leiden tot wijzigingen in deze
            privacy statement. Het is daarom raadzaam om
            regelmatig deze privacy statement te raadplegen.
          </p>
          <p>
            <strong>Persoonlijke gegevens</strong>
          </p>
          <p>
            Door het invullen van formulieren op de website
            van Synsel Techniek geef je toestemming aan
            Synsel Techniek om de gegevens te registreren in
            een database. Je gegevens worden gebruikt voor
            de normale bedrijfsdoeleinden van Synsel
            Techniek. Daarnaast legt Synsel Techniek
            gegevens vast om haar dienstverlening te
            verbeteren en om je op de hoogte te houden van
            (nieuwe) diensten. Mailingen zijn, conform de
            wet op de telecommunicatie, voorzien van een
            afmeldlink (Opt-out) en een link met de
            mogelijkheid om je gegevens aan te passen.
            Synsel Techniek zal jouw persoonlijke gegevens
            niet aan derden verkopen.
          </p>
          <p>
            <strong>Cookies</strong>
          </p>
          <p>
            Deze website maakt gebruik van “cookies”.
            Cookies zijn kleine stukjes informatie die door
            je browser worden opgeslagen op je computer. Wij
            gebruiken deze informatie om te onthouden hoe je
            deze website gebruikt, om rapporten over de
            website-activiteiten op te stellen en andere
            diensten aan te bieden met betrekking tot de
            website-activiteiten en het internetgebruik. Op
            basis van de cookies tonen wij je bijvoorbeeld
            eerder bekeken vacatures, indien deze nog online
            staan. Bij het bezoeken van de website van
            Synsel Techniek wordt jou gevraagd of je de
            cookies wilt inschakelen. Klik op “Cookies
            toestaan” om cookies in te schakelen. De website
            van Synsel Techniek maakt gebruik van de
            volgende type cookies:
          </p>
          <p>
            <strong>
              <u>Functionele cookies</u>
            </strong>
          </p>
          <p>
            Functionele cookies zijn nodig om de Synsel
            Techniek website goed te laten functioneren.
            Deze cookies onthouden bijvoorbeeld jouw
            taalinstelling zodat je deze niet na elk bezoek
            opnieuw hoeft in te stellen.
          </p>
          <p>
            <strong>Analytische cookies</strong>
          </p>
          <p>
            Meten is weten. Analytische cookies helpen ons
            de website te verbeteren. Dankzij het gebruik
            van Analytische cookies kan Synsel Techniek haar
            website verder optimaliseren en beter laten
            aansluiten op de wensen van bezoekers. Synsel
            Techniek gebruikt de volgende Analytische
            cookies:
          </p>
          <p>
            <strong>
              <u>Google Analytics cookie:</u>
            </strong>
            <br />
            Met deze cookie houden we bij hoe gebruikers de
            website gebruiken en hoe effectief onze
            Adwords-advertenties bij Google
            zoekresultaatpagina’s zijn. Het doel is om deze
            informatie te gebruiken bij het optimaliseren
            van onze dienstverlening en onze website. Het
            gaat hierbij om cijfermatige gegevens en totalen
            waarbij de identiteit van de bezoeker niet van
            belang is. De aldus verkregen informatie wordt,
            met inbegrip van het adres van uw computer
            (IP-adres), overgebracht naar en door Google
            opgeslagen op servers in de Verenigde Staten.
            Lees het{' '}
            <a href="https://www.google.com/intl/nl/policies/privacy/">
              privacy beleid
            </a>{' '}
            van Google voor meer informatie.
          </p>
          <p>
            Google gebruikt deze informatie om bij te houden
            hoe onze website gebruikt wordt, om zo rapporten
            over de website aan ons te kunnen verstrekken en
            om haar adverteerders informatie over de
            effectiviteit van hun campagnes te kunnen
            bieden. Google kan deze informatie aan derden
            verschaffen indien Google hiertoe wettelijk
            wordt verplicht, of voor zover deze derden de
            informatie namens Google verwerken. Wij hebben
            hier geen invloed op.
          </p>
          <p>
            <strong>
              <u>Hotjar cookie:</u>
            </strong>
            <br />
            Met deze cookie kunnen wij specifieke pagina’s
            meten op scroll-, kijk- en klikgedrag om zo
            bepaalde pagina’s te verbeteren. Ook kunnen we
            met deze cookie op specifieke pagina’s
            formulieren tonen zoals polls. Lees hier de{' '}
            <a href="https://www.hotjar.com/privacy">
              privacy beleid
            </a>{' '}
            van Hotjar.
          </p>
          <p>
            <strong>Tracking (Marketing) cookies</strong>
          </p>
          <p>
            Met jouw toestemming plaatsen wij “tracking
            cookies” op je computer. Deze cookies gebruiken
            wij voor marketingdoeleinden, zoals het
            bijhouden van welke pagina’s je bezoekt om zo
            een profiel op te bouwen van jouw online gedrag.
            Dit profiel is niet gekoppeld aan je naam,
            adres, e-mailadres of dergelijke persoonlijke
            informatie, maar alleen om advertenties af te
            stemmen op je profiel zodat deze zo veel
            mogelijk relevant voor je zijn. Wij gebruiken
            hiervoor de volgende cookies:
          </p>
          <p>
            <strong>
              <u>Google Analytics Remarketing:</u>
            </strong>
            <br />
            Met Google Analytics meten we hoe je de website
            van Synsel Techniek gebruikt. Deze kennis
            gebruiken we om je te helpen bij het tonen van
            de juiste vacatures of andere diensten van
            Synsel Techniek. Zonder deze cookie mis je
            persoonlijke aanbevelingen op onze website.
          </p>
          <p>
            <strong>
              <u>Social Media</u>
              <br />
            </strong>
            Op deze site zijn knoppen opgenomen om pagina’s
            te kunnen promoten of delen op sociale netwerken
            Facebook en LinkedIn. Deze knoppen worden
            gerealiseerd door code die wordt aangeleverd
            door Facebook en LinkedIn zelf. Deze code
            plaatst onder meer een cookie.
          </p>
          <p>
            <strong>
              <u>Facebook</u>
            </strong>
            <br />
            Deze cookie ziet welke (vacature)pagina’s je
            bekijkt. Zo kunnen we je relevante advertenties
            tonen op Facebook.
          </p>
          <p>
            <strong>Cookies uitzetten</strong>
          </p>
          <p>
            De meeste browsers zijn standaard ingesteld om
            cookies te accepteren, maar je kunt de browser
            opnieuw instellen om alle cookies te weigeren of
            om aan te geven wanneer een cookie wordt
            verzonden. Dit is echter niet raadzaam om te
            doen. Het is mogelijk dat sommige functies en
            services op websites niet correct functioneren
            als cookies zijn uitgeschakeld in je browser.
          </p>
          <p>
            <strong>Links naar andere websites</strong>
          </p>
          <p>
            Onze websites bevatten links naar relevante
            websites. Besef dat als je klikt op zo’n link je
            onze website hebt verlaten en wij geen
            zeggenschap noch controle hebben over die
            websites. We kunnen de informatie die je deelt
            op die sites en/of de geheimhouding ervan dan
            ook niet garanderen. Deze websites vallen
            vanzelfsprekend ook niet onder ons
            privacybeleid. Check alvorens informatie te
            verstrekken op die websites goed naar hun
            privacybeleid.
          </p>
          <p>
            <strong>Reageren op vacatures</strong>
          </p>
          <p>
            Om je in staat te stellen te reageren op een
            vacature op onze website hebben wij een aantal
            gegevens van je nodig. Je bepaalt zelf welke
            gegevens je aan ons verstrekt, maar sommige
            gegevens zijn verplicht om aan ons door te
            geven. Wij gebruiken deze gegevens uitsluitend
            om jou onder de aandacht te brengen van onze
            opdrachtgevers, zodat we je zo snel mogelijk aan
            een baan kunnen helpen. Wanneer je het
            inschrijfformulier invult, geef je daarmee
            expliciet toestemming aan Synsel Techniek om
            jouw persoonlijke gegevens te bewaren en aan een
            opdrachtgever ter beschikking te stellen, totdat
            jij aangeeft dit niet meer te willen.
            Vanzelfsprekend is dat elke opdrachtgever aan
            wie wij jouw gegevens doorgeven, ook gehouden is
            om jouw privacy te respecteren.
          </p>
          <p>
            <strong>
              Gegevens wijzigen en verwijderen
            </strong>
          </p>
          <p>
            Je kunt op elk gewenst moment besluiten om je CV
            aan te passen of je accountgegevens te wijzigen.
            Ook kun je op ieder moment aangeven dat je jouw
            gegevens bij Synsel Techniek verwijderd wil
            hebben. Je kunt je verzoek richten aan{' '}
            <a href="mailto:info@synsel.nl">
              info@synsel.nl
            </a>{' '}
            en Synsel Techniek zal zo snel mogelijk aan je
            verzoek voldoen.
          </p>
          <p>
            <em>
              Deze pagina is voor het laatst aangepast op
              04-07-2017.
            </em>
          </p>
          <p>&nbsp;</p>
        </TextContent>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
